import { inject } from '@angular/core'
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { Observable, from, of } from 'rxjs'
import { map } from 'rxjs/operators'

export const redirectByRoleGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService)
  const router = inject(Router)
  const params = new URLSearchParams(window.location.search);

  if (params.get('code')) {
    router.navigate(['/login/callback'], { queryParams: { code: params.get('code'), state: params.get('state') } })
    return of(false)
  }

  if (!authService.isLoggedIn()) {
    router.navigate(['/login'])
    return of(false)
  }

  return from(authService.getUserInfo()).pipe(
    map((userInfo) => {
      if (!userInfo) {
        router.navigate(['/login'])
        return false
      }

      switch (userInfo.role) {
        case 'admin':
          router.navigate(['/admin'])
          break
        case 'mandatary':
          router.navigate(['/mandatary'])
          break
        default:
          router.navigate(['/login'])
      }
      return false
    }),
  )
}
